const FiltersState: TableFilters = {
  keyword: '',
  organization: '',
  limit: '5',
  page: 1,
};

export default FiltersState;
